module.exports = __webpack_public_path__ + "static/media/15d-01-HOME_ST-9-2015-1524x3048mm-oleo-sobre-madera.8aa9e6ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15d/15d-01-HOME_ST-9-2015-1524x3048mm-oleo-sobre-madera.jpg
// module id = 169
// module chunks = 0